import { PageProps, graphql } from 'gatsby';
import * as React from 'react';
import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import {
  getHelmetPropsFromMetatagProps,
  getJsonFromMetatagProps,
} from '../../utils/metatagHelpers';
import ArticleTemplate from './ArticleTemplate';

interface IRelatedArticleCards {
  edges: {
    node: IArticleCard;
  }[];
}

interface DataProps {
  node: IArticleContent;
  relatedArticles: IRelatedArticleCards;
  backfillArticles: IRelatedArticleCards;
  allStorageBrazeCard: AllStorageBrazeCards;
  translations: Translations;
  mainMenuDrupalEdges: NerdMenuDrupalEdges;
  footerMenuDrupalEdges: NerdMenuDrupalEdges;
  footerUtilityMenuDrupalEdges: NerdMenuDrupalEdges;
}

const ArticlePage: React.FC<PageProps<DataProps>> = function (props) {
  const {
    data: {
      node,
      translations,
      mainMenuDrupalEdges,
      footerMenuDrupalEdges,
      footerUtilityMenuDrupalEdges,
    },
  } = props;

  const helmetProps = getHelmetPropsFromMetatagProps(node.metatag);
  const schemaMarkup = getJsonFromMetatagProps(node.metatag);
  return (
    <Layout
      node={node}
      metaData={node.metatag}
      language={node.langcode}
      translations={translations}
      mainMenuDrupalEdges={mainMenuDrupalEdges}
      footerMenuDrupalEdges={footerMenuDrupalEdges}
      footerUtilityNodeDrupalEdges={footerUtilityMenuDrupalEdges}
    >
      <Seo {...helmetProps} schemaMarkup={schemaMarkup} />
      <ArticleTemplate {...props} />
    </Layout>
  );
};

export const query = graphql`
  query ($id: String!, $language: String!, $nid: Int!, $species: Int, $tags: [Int]) {
    node: nodeArticle(id: { eq: $id }, langcode: { eq: $language }) {
      ...ArticlePage
    }
    translations: allNodeArticle(
      filter: { drupal_internal__nid: { eq: $nid }, langcode: { ne: $language } }
    ) {
      edges {
        node {
          langcode
          path {
            alias
          }
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    relatedArticles: allNodeArticle(
      limit: 3
      sort: [{ sticky: DESC }, { created: DESC }]
      filter: {
        field_tags: { elemMatch: { drupal_internal__target_id: { in: $tags } } }
        id: { ne: $id }
        langcode: { eq: $language }
      }
    ) {
      edges {
        node {
          ...ArticleCard
        }
      }
    }
    allStorageBrazeCard(
      filter: { langcode: { eq: $language }, field_location_region: { in: "article_detail" } }
      sort: { created: DESC }
    ) {
      edges {
        node {
          ...StorageBrazeCard
        }
      }
    }
    backfillArticles: allNodeArticle(
      limit: 3
      filter: {
        field_species_term: { drupal_internal__target_id: { eq: $species } }
        id: { ne: $id }
        langcode: { eq: $language }
      }
    ) {
      edges {
        node {
          ...ArticleCard
        }
      }
    }
    mainMenuDrupalEdges: allNerdMenuNerdMenu(
      filter: { langcode: { eq: $language }, menu_id: { eq: "main" } }
    ) {
      edges {
        node {
          ...NerdMenuFragment
        }
      }
    }
    footerMenuDrupalEdges: allNerdMenuNerdMenu(
      filter: { langcode: { eq: $language }, menu_id: { eq: "footer" } }
    ) {
      edges {
        node {
          ...NerdMenuFragment
        }
      }
    }
    footerUtilityMenuDrupalEdges: allNerdMenuNerdMenu(
      filter: { langcode: { eq: $language }, menu_id: { eq: "footer-utility" } }
    ) {
      edges {
        node {
          ...NerdMenuFragment
        }
      }
    }
  }
`;

export default ArticlePage;
